import React from 'react';
// react plugin used to create datetimepicker
import ReactDatetime from "react-datetime";
import {  FormGroup } from "reactstrap";

const Datepicker = (props) => {

  return (
    <>
       <FormGroup>
                  <ReactDatetime
                    inputProps={{
                      className: "form-control",
                      placeholder: props.placeholder,
                    }}
                    timeFormat={false}
                  />
                </FormGroup>
    </>
  )
}

export default Datepicker
